import { TextToVoiceIcon } from '@rsos/assets/icons';
import { Box, Loader } from '@rsos/base-components';
import TTVButton from './IconButton';

const TextToVoiceToggle = ({
  isSelected,
  disabled = false,
  isLoading = false,
  tooltip = 'Text to Voice',
  onClick = () => {},
}) => {
  const handleClick = () => {
    if (disabled || isLoading) {
      return;
    }
    onClick();
  };

  return (
    <div data-name="text-to-voice-toggle">
      <TTVButton
        grow={false}
        btnType="secondary"
        noMargin
        onClick={handleClick}
        selected={isSelected}
        disabled={disabled || isLoading}
        dataName="transcript-ttv-button"
        tooltip={tooltip}
      >
        <Box as="span">
          {isLoading ? (
            <Loader size={14} color="currentColor" />
          ) : (
            <TextToVoiceIcon height={14} width={14} />
          )}
        </Box>
      </TTVButton>
    </div>
  );
};

export default TextToVoiceToggle;
